// DS: MO1.3
import React from 'react';
import classnames from 'classnames';
import { useTranslation } from 'react-i18next';
import Heading from '@wix/da-a11y/pkg/components/headings/Heading';
import { Section } from '@wix/da-a11y/pkg/components/headings/tagWrappers';
import SophisticatedTooltip from '@wix/da-ds/pkg/tooltips/dsPreset/SophisticatedTooltip';
import PlainButtonOrLink from '@wix/da-ds/pkg/Buttons/PlainButtonOrLink';
import GhostButton from '@wix/da-ds/pkg/Buttons/GhostButton';
import { IconSize } from '@wix/da-ds/pkg/Icons/IconWrap';
import Info from '@wix/da-ds/pkg/Icons/16x16/Info';
import Edit from '@wix/da-ds/pkg/Icons/24x24/Edit';
import s from './NftDetails.scss';
const NftDetails = ({ deviation, nft, isOwner, showNftEditPopup })=>{
    const { t } = useTranslation();
    return /*#__PURE__*/ React.createElement(Section, {
        className: s['root']
    }, /*#__PURE__*/ React.createElement(Heading, {
        className: s['heading']
    }, t('deviation.nft.heading'), /*#__PURE__*/ React.createElement(SophisticatedTooltip, {
        size: "large",
        width: 224,
        heading: t('deviation.nft.heading.tooltip.title'),
        description: t('deviation.nft.heading.tooltip.text', {
            postProcess: [
                'reactPostprocessor',
                'featureBrancher'
            ],
            br: /*#__PURE__*/ React.createElement("br", null),
            learnMore: /*#__PURE__*/ React.createElement("a", {
                target: "_blank",
                rel: "noopener noreferrer",
                href: t('deviation.nft.heading.tooltip.learnMore.url'),
                className: classnames(s['learn-more'], 'text-link-level-1-brand')
            }, t('deviation.nft.heading.tooltip.learnMore.label'))
        }),
        className: s['heading-icon']
    }, /*#__PURE__*/ React.createElement(Info, {
        size: IconSize.SMALLER
    })), isOwner && /*#__PURE__*/ React.createElement(PlainButtonOrLink, {
        className: s['edit-icon'],
        onClick: ()=>showNftEditPopup(deviation, nft)
    }, /*#__PURE__*/ React.createElement(Edit, null))), /*#__PURE__*/ React.createElement("ul", {
        className: s['items']
    }, /*#__PURE__*/ React.createElement("li", {
        key: "contract",
        className: s['item']
    }, /*#__PURE__*/ React.createElement("dl", null, /*#__PURE__*/ React.createElement("dt", {
        className: s['item-name']
    }, t('deviation.nft.item.contract')), /*#__PURE__*/ React.createElement("dd", {
        className: s['contract']
    }, /*#__PURE__*/ React.createElement("span", {
        className: s['contract-prefix']
    }, `0x${nft.blockchainIdentifierPrimary.slice(0, -4)}`), /*#__PURE__*/ React.createElement("span", {
        className: s['contract-postfix']
    }, nft.blockchainIdentifierPrimary.slice(-4))))), /*#__PURE__*/ React.createElement("li", {
        key: "blockchain",
        className: s['item']
    }, /*#__PURE__*/ React.createElement("dl", null, /*#__PURE__*/ React.createElement("dt", {
        className: s['item-name']
    }, t('deviation.nft.item.blockchain')), /*#__PURE__*/ React.createElement("dd", {
        className: classnames(s['item-value'], s['blockchain'])
    }, nft.blockchainName.toLowerCase()))), nft.blockchainIdentifierSecondary && /*#__PURE__*/ React.createElement("li", {
        key: "token",
        className: s['item']
    }, /*#__PURE__*/ React.createElement("dl", null, /*#__PURE__*/ React.createElement("dt", {
        className: s['item-name']
    }, t('deviation.nft.item.token')), /*#__PURE__*/ React.createElement("dd", {
        className: s['item-value']
    }, nft.blockchainIdentifierSecondary)))), nft.externalLinks.map((link)=>{
        if (link.type === 'marketplace') {
            return /*#__PURE__*/ React.createElement(GhostButton, {
                className: s['cta'],
                key: `${link.name}-${link.url}`,
                size: "large",
                variant: "main",
                target: "_blank",
                href: link.url
            }, link.name && link.name !== 'deviation_custom_marketplace_url' ? t('deviation.nft.marketplace.named', link) : t('deviation.nft.marketplace.unnamed'));
        }
        return null;
    }), /*#__PURE__*/ React.createElement("div", {
        className: s['protect']
    }, t('deviation.nft.footer.protect.label', {
        postProcess: [
            'reactPostprocessor',
            'featureBrancher'
        ],
        protect: /*#__PURE__*/ React.createElement("a", {
            target: "_blank",
            rel: "noopener noreferrer",
            href: t('deviation.nft.footer.protect.link.url'),
            className: s['protect-link']
        }, t('deviation.nft.footer.protect.link.label'))
    })));
};
NftDetails.displayName = 'NftDetails';
export default NftDetails;
